import React from "react";
import { useLocation } from "react-router-dom";
import CalculusModuleSubtopic from "../CalculusModuleSubtopic";

const Gamma = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <CalculusModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Gamma"
      videos={[
        "https://www.youtube.com/embed/I7RWAQgMRVI?list=PLNKD1qB9ppttGqVnTA4u9wckS6bCeLp99",
        "https://www.youtube.com/embed/LA-hbdg8CK4?list=PLNKD1qB9ppttGqVnTA4u9wckS6bCeLp99"
      ]}
      takeaways={[]}
      questions={[]}
      exampleVideos={[
        "https://www.youtube.com/embed/Vi5lF_IgBSg?list=PLNKD1qB9ppttGqVnTA4u9wckS6bCeLp99",
        "https://www.youtube.com/embed/Oh0f_EkYA5g?list=PLNKD1qB9ppttGqVnTA4u9wckS6bCeLp99"
      ]}
    />
  );
}

export default Gamma;
